import { __assign } from "tslib";
import 'd3-transition';
import { interpolate } from 'd3-interpolate';
import { select } from 'd3-selection';
export var createArcTween = function (currentArc, updatedArc, arc) {
    var copy = __assign({}, currentArc);
    return function () {
        var interpolateStartAngle = interpolate(currentArc.startAngle, updatedArc.startAngle), interpolateEndAngle = interpolate(currentArc.endAngle, updatedArc.endAngle);
        return function (t) {
            copy.startAngle = interpolateStartAngle(t);
            copy.endAngle = interpolateEndAngle(t);
            return arc(copy);
        };
    };
};
export var animateArcPath = function (element, tween, onMotionEnd, duration) {
    if (duration === void 0) { duration = 500; }
    select(element.current)
        .transition()
        .duration(duration)
        .attrTween('d', tween)
        .on('end', onMotionEnd);
};
